<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="warn" [mat-dialog-close]="true">{{ data.confirmButtonText || 'Delete' }}</button>
  <button mat-flat-button mat-dialog-close>{{ data.cancelButtonText || 'Cancel' }}</button>
</mat-dialog-actions>
